/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLetterCaseLower = createReactComponent(
  "letter-case-lower",
  "IconLetterCaseLower",
  [
    [
      "path",
      {
        d: "M6.5 15.5m-3.5 0a3.5 3.5 0 1 0 7 0a3.5 3.5 0 1 0 -7 0",
        key: "svg-0"
      }
    ],
    ["path", { d: "M10 12v7", key: "svg-1" }],
    [
      "path",
      {
        d: "M17.5 15.5m-3.5 0a3.5 3.5 0 1 0 7 0a3.5 3.5 0 1 0 -7 0",
        key: "svg-2"
      }
    ],
    ["path", { d: "M21 12v7", key: "svg-3" }]
  ]
);

export { IconLetterCaseLower as default };
//# sourceMappingURL=IconLetterCaseLower.js.map
